import React from "react";
import { useMenListing, useListingObserver, useListingProfile, menProfileKey } from "../hooks/useMenListing";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Base64, fetchData, postData, SmartImageComponent, turntoacronym } from "../components/misc";
import { GeneralModal, Loader } from "../components/profile";
import MenComponent from "../components/mens";
import { uploadFile } from "../utils/uploadFile";
import { trackEvent } from "../utils/bridge.js";
import ExpiredAccountModal from "../components/ExpiredAccountModal.js";

const videoEnabledPackages = new Set(["EMERALD", "SAPPHIRE", "DIAMOND", "RUBY"])
const CALL_INITIATED_MESSAGE = "[[    ---- CALL INITIATED ----    ]]"
const PACKAGE_CONTACT_ORDER = ["BRONZE", "SILVER", "GOLD", "PLATINUM", "DIAMOND", "EMERALD", "SAPPHIRE", "RUBY"]
let sharedCallAudioContext = null;

function chatTrackingContext({ womandata, male, gender, senderPackage }) {
    const senderIsMale = gender === "Male";
    return {
        viewer_email: senderIsMale ? (male?.EMAIL || '') : (womandata?.EMAIL || ''),
        viewed_email: senderIsMale ? (womandata?.EMAIL || '') : (male?.EMAIL || ''),
        viewed_name: senderIsMale ? (womandata?.fullname1 || '') : (male?.fullname1 || ''),
        male_email: male?.EMAIL || '',
        woman_email: womandata?.EMAIL || '',
        gender,
        package: senderPackage || '',
    };
}

function startTimedBridgeEvent(ref, eventName, context) {
    if (!context?.viewed_email || ref.current?.startedAt) {
        return;
    }
    ref.current = { startedAt: Date.now(), eventName, context, finished: false };
    trackEvent(eventName.replace('_duration', '_started'), context);
}

function finishTimedBridgeEvent(ref, exitReason = 'unmount') {
    const tracking = ref.current;
    if (!tracking || tracking.finished) {
        return;
    }
    tracking.finished = true;
    const durationMs = Math.max(Date.now() - tracking.startedAt, 0);
    trackEvent(tracking.eventName, {
        ...tracking.context,
        duration_ms: durationMs,
        duration_seconds: Math.round(durationMs / 1000),
        exit_reason: exitReason,
    });
}

function getCallAudioContext() {
    const AudioContextConstructor = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextConstructor) {
        return null;
    }
    if (!sharedCallAudioContext) {
        sharedCallAudioContext = new AudioContextConstructor();
    }
    return sharedCallAudioContext;
}

export function primeCallAudioFromUserGesture() {
    const context = getCallAudioContext();
    if (context && context.state === "suspended") {
        context.resume();
    }
}

const endingconversations = [
  {
    "Got back": "I got back in the middle of the night. Just getting up. Will text you when I recover my bearings."
  },
  {
    "Same page": "We aren't on the same page. Sorry. I wish you the best."
  },
  {
    "Up and about A": "I think we are into each other and are ready to take matters to the next step. So let the rubber hit the road. With the other ladies I've spoken to here desire hasn't really met with expectations. So I'll lead and ask the sensitive questions. You can also ask questions. I have five. If we like the answers let's meet and drink coffee and kiss. Cool?"
  },
  {
    "Up and about B": "Up and about. Ready for a discussion that leads to a meet."
  },
  {
    "Comfortable": "Are you uncomfortable discussing marriage failure rates and divorce, prenups, child custody, gender roles and the like"
  },
  {
    "Prenup A": "I require a prenup. It’s non-negotiable. It protects both of us. It must clearly state that if the marriage ends, each person leaves with what they came with. There’s no entitlement to assets built before the marriage, and if we buy anything together, we split it based on contribution, not emotion."
  },
  {
    "Prenup B": "69% of marriages are ending in divorce with the wife being the initiator. How do you feel about signing a prenup before marriage?"
  },
  {
    "Custody A": "Who should get custody of the children in case of a divorce?"
  },
  {
    "Custody A": "Joint custody is the default. If we separate, custody is 50/50, legally binding. If you remarry, primary custody reverts to me, not to your new husband. Our kids will not be raised in a household with a man I didn’t choose. Parenting responsibilities both emotional and financial, are shared equally. No exceptions."
  },
  {
    "Gender roles A": "What’s your view on gender roles in marriage?"
  },
  {
    "Gender roles B": "Gender roles are non-negotiable: I’m the leader, period. You obey. If you don’t like my decisions, you can complain to your diary, not to me. I’ll handle the money, the house, the rules. You’ll cook, clean, raise the kids, and support me—quietly. If you ever try to challenge my authority, that’s a breach of marriage to me. I don’t want a ‘partner,’ I want a wife who knows her place. If that sounds harsh, good, it weeds out the wrong women fast."
  },
  {
    "Working A": "Would you support me working full-time after we have children?"
  },
  {
    "Working B": "I’d prefer that you work part-time or take time off, especially in the early years. A child needs emotional presence, not just money. If you feel your career must always come first—even when the kids are small,I don’t think we’re compatible."
  },
  {
    "Separate ways A": "What happens if the marriage doesn’t work out,do we just split and go our separate ways?"
  },
  {
    "Separate ways B": "No. If you initiated the separation without serious cause like abuse or infidelity, I expect you to leave without claims on my property, without alimony, and without the children becoming leverage. Marriage is not a business exit strategy."
  },
  {
    "Question": "I think it is best for me to ask the substantive questions that would make or break a relationship then we can deal with the mechanics of a relationship. What say you?"
  },
  {
    "Goodbye": "We aren't on the same page. Sorry. I wish you the best."
  }
]

export function loadprofile(url, setCallback, setLoadingCallback) {
    console.log(setLoadingCallback)
    fetchData(url).then((data) => { 
        console.log("With url: ", url)
        console.log(data);

        if (data.responsecode === 200) {
            setCallback(data.data)
            setLoadingCallback(false)
        } else {
            alert("Something went wrong. Please contact support.")
        }
    }).catch((error) => {
        console.error("Error fetching auth codes:", error);
        throw error;
    })

}

export function canSendAsMan(male, womandata) {
    return Boolean(male?.fullname1 && womandata?.__id)
}

async function copyMessageToClipboard(text) {
    const messageText = String(text || "");
    if (!messageText) {
        return;
    }

    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(messageText);
        return;
    }

    const textArea = document.createElement("textarea");
    textArea.value = messageText;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    try {
        document.execCommand("copy");
    } finally {
        document.body.removeChild(textArea);
    }
}

function WomansProfileBadge({ profile }) {
    if (!profile?.womansprofile) {
        return null;
    }

    return <p>Woman's profile: {profile.womansprofile}</p>;
}

function VideoEmbed({ src }) {
    return (
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
                src={src}
                loading="lazy"
                style={{
                    border: "none",
                    position: "absolute",
                    top: "0",
                    height: "100%",
                    width: "100%",
                }}
                allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
                allowFullScreen={true}
                title="Uploaded video"
            ></iframe>
        </div>
    );
}

const UPLOADED_IMAGE_URL_PATTERN = /^\/api\/uploads\/\S+\.(png|jpe?g|gif|webp|bmp|svg)$/i;

function isUploadedImageUrl(text) {
    return typeof text === "string" && UPLOADED_IMAGE_URL_PATTERN.test(text.trim());
}

function ImageEmbed({ src }) {
    return (
        <img
            src={src}
            loading="lazy"
            className="rounded-lg max-w-full max-h-80 object-contain"
            alt="Uploaded"
        />
    );
}

function ChatUploadMenu({
    onImageSelect,
    onVideoSelect,
    isUploadingImage = false,
    isUploadingVideo = false,
    disabled = false,
    buttonClassName = "",
    menuClassName = "",
}) {
    const [isOpen, setIsOpen] = React.useState(false);
    const menuRef = React.useRef(null);

    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        function handleDocumentClick(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleDocumentClick);
        return () => document.removeEventListener("mousedown", handleDocumentClick);
    }, [isOpen]);

    const handleOptionClick = (callback) => {
        setIsOpen(false);
        callback();
    };

    return (
        <div className="relative flex-shrink-0" ref={menuRef}>
            <button
                type="button"
                className={buttonClassName}
                onClick={() => setIsOpen((current) => !current)}
                disabled={disabled || isUploadingImage || isUploadingVideo}
                aria-haspopup="menu"
                aria-expanded={isOpen}
                aria-label="Open upload options"
                title="Upload"
            >
                {isUploadingImage || isUploadingVideo ? "⏳" : "+"}
            </button>
            {isOpen ? (
                <div className={`absolute bottom-full left-0 z-30 mb-2 min-w-44 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl ${menuClassName}`} role="menu">
                    <button
                        type="button"
                        className="block w-full px-4 py-2 text-left text-sm text-gray-900 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => handleOptionClick(onImageSelect)}
                        disabled={disabled || isUploadingImage}
                        role="menuitem"
                    >
                        🖼️ Upload picture
                    </button>
                    <button
                        type="button"
                        className="block w-full px-4 py-2 text-left text-sm text-gray-900 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                        onClick={() => handleOptionClick(onVideoSelect)}
                        disabled={disabled || isUploadingVideo}
                        role="menuitem"
                    >
                        🎥 Upload video
                    </button>
                </div>
            ) : null}
        </div>
    );
}

function isCallInitiatedMessage(text) {
    if (typeof text !== "string") {
        return false;
    }

    const normalizedText = text.replace(/\s+/g, " ").trim();
    return /^\[\[\s*---- CALL INITIATED ----\s*\]\]$/i.test(normalizedText);
}

function getReachablePackages(senderPackage) {
    const normalizedPackage = String(senderPackage || "").trim().toUpperCase();
    if (normalizedPackage === "BRONZE") {
        return PACKAGE_CONTACT_ORDER;
    }
    if (normalizedPackage === "SILVER") {
        return ["SILVER", "GOLD", "PLATINUM", "DIAMOND", "EMERALD", "SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "GOLD") {
        return ["GOLD", "PLATINUM", "DIAMOND", "EMERALD", "SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "PLATINUM") {
        return ["PLATINUM", "DIAMOND", "EMERALD", "SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "DIAMOND") {
        return ["DIAMOND", "EMERALD", "SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "EMERALD") {
        return ["EMERALD", "SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "SAPPHIRE") {
        return ["SAPPHIRE", "RUBY"];
    }
    if (normalizedPackage === "RUBY") {
        return ["RUBY"];
    }
    return PACKAGE_CONTACT_ORDER;
}

function canContactByPackage(senderPackage, recipientPackage) {
    const normalizedRecipient = String(recipientPackage || "").trim().toUpperCase();
    if (!normalizedRecipient) {
        return true;
    }
    return getReachablePackages(senderPackage).includes(normalizedRecipient);
}

function canInitiateCallByPackage(senderPackage) {
    return String(senderPackage || "").trim().toUpperCase() === "SAPPHIRE";
}

function CallStatusMessage({ isOutgoing = false }) {
    const iconColorClass = isOutgoing ? "text-green-500" : "text-red-500";
    const label = isOutgoing ? "You called" : "Missed call";

    return (
        <div className="flex items-center space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${iconColorClass}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h2.28a2 2 0 011.897 1.368l1.02 3.06a2 2 0 01-.454 2.11l-1.2 1.2a16 16 0 006.364 6.364l1.2-1.2a2 2 0 012.11-.454l3.06 1.02A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <span>{label}</span>
        </div>
    );
}

function MessageBody({ text, isOutgoing = false }) {
    if (typeof text === "string" && text.includes("player.mediadelivery.net")) {
        return <VideoEmbed src={text+"?autoplay=false"} />;
    }

    if (isUploadedImageUrl(text)) {
        return <ImageEmbed src={text} />;
    }

    if (isCallInitiatedMessage(text)) {
        return <CallStatusMessage isOutgoing={isOutgoing} />;
    }

    return <p className="whitespace-pre-wrap">{text}</p>;
}

function MansMessage(props) {
    const navigate = useNavigate()
    const messageIsRead = Boolean(props.read)
    const bubbleStyle = messageIsRead
        ? {
            background: "linear-gradient(135deg, #8f6834, #bd9154)",
            border: "1px solid rgba(228,199,157,.55)",
            color: "#fffaf3",
            boxShadow: "0 10px 24px rgba(58,26,34,.16)",
        }
        : {
            background: "linear-gradient(135deg, #512430, #3a1a22)",
            border: "1px solid rgba(228,199,157,.28)",
            color: "#fffaf3",
            boxShadow: "0 10px 24px rgba(58,26,34,.16)",
        }
    return (
        <div className="flex justify-start mb-4" key={props.key} onClick={() => {
            if (props.onClick) {
                props.onClick();
            } else {
                console.log("No onClick function provided for this message.");
            }
        }}>
                {props.male
                    ? <SmartImageComponent cssclasses="object-cover h-8 w-8 rounded-full" src={"/profilepic/1?EMAIL="+props.male.EMAIL} id={"Pic of:" + props.male.fullname1} backup={props.hideimage||true} onClickFunction={() => navigate("/profile/"+Base64.encode(props.male.fullname1))} />
                    : null
                }
                <div className="mr-2 flex flex-col items-start min-w-[80%]">
                    <div className="py-3 px-4 rounded-bl-3xl rounded-tl-3xl rounded-tr-xl text-base normal-case whitespace-pre-wrap w-full" style={bubbleStyle}>
                        <MessageBody text={props.text} isOutgoing={props.isOutgoing} />
                    </div>
                    {props.showReadStatus && messageIsRead
                        ? <p className="mt-1 text-xs text-amber-700">Read by woman</p>
                        : null
                    }
                    {props.showCopy
                        ? (
                            <button
                                type="button"
                                className="mt-1 text-xs text-blue-700 underline"
                                aria-label="Copy message"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    if (props.onCopy) {
                                        props.onCopy(props.text);
                                    }
                                }}
                            >
                                {props.copied ? "Copied" : "Copy message"}
                            </button>
                        )
                        : null
                    }
                </div>

                {/* <div className="text-gray-200 text-xs">{props.delivered ? <>Delivered</> : <>Sending</>}</div> */}
        </div>
    )
}

function WomansMessage(props) {
    const navigate = useNavigate()
    const bubbleStyle = {
        background: "linear-gradient(135deg, #fffaf3, #f2e4cc)",
        border: "1px solid rgba(189,145,84,.32)",
        color: "#3a1a22",
        boxShadow: "0 10px 24px rgba(58,26,34,.10)",
    }
    return (
        <div className="flex justify-end mb-4" key={props.key} onClick={() => {
            if (props.onClick) {
                props.onClick();
            } else {
                console.log("No onClick function provided for this message.");
            }
        }}>
                {props.male
                    ? <SmartImageComponent cssclasses="object-cover h-8 w-8 rounded-full" src={"/profilepic/1?EMAIL="+props.womandata.EMAIL} id={"Pic of:" + props.womandata.EMAIL} backup={props.hideimage||true} onClickFunction={() => navigate("/profile/"+Base64.encode(props.womandata.EMAIL))}/>
                    : null
                }
                <div className="ml-2 flex flex-col items-end min-w-[80%]">
                    <div className="py-3 px-4 rounded-br-3xl rounded-tr-3xl rounded-tl-xl text-base normal-case w-full" style={bubbleStyle}>
                        <MessageBody text={props.text} isOutgoing={props.isOutgoing} />
                        <p className="text-xs" style={{color: "#8f6834"}}>{props.delivered ? <>Delivered</> : <>Sending</>}</p>
                    </div>
                    {props.showCopy
                        ? (
                            <button
                                type="button"
                                className="mt-1 text-xs text-gray-600 underline"
                                aria-label="Copy message"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    if (props.onCopy) {
                                        props.onCopy(props.text);
                                    }
                                }}
                            >
                                {props.copied ? "Copied" : "Copy message"}
                            </button>
                        )
                        : null
                    }
                </div>
        </div>
    )
}

export default function AllChats() {
    const [activatedprofiles, setActivatedProfiles] = React.useState([])
    const [searchtext, setSearchText] = React.useState("")

    const [loading, setLoading] = React.useState(true)
    const [visiblePackages, setVisiblePackages] = React.useState({})
    const [allProfilesVisible, setAllProfilesVisible] = React.useState(false)
    const [nonMessagedVisible, setNonMessagedVisible] = React.useState(false)
    
    function loadchats(signal) {
        fetchData("/api/sirri_api/get_women", { signal }).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                const allowedProfiles = (data.acc || []).filter(
                    (profile) => !(profile && profile.denialofservice)
                )
                setActivatedProfiles(allowedProfiles)
                setLoading(false)
            }
        }).catch((error) => {
            console.error("Error fetching auth codes:", error);
            throw error;
        });
    }

    React.useEffect(() => {
        const controller = new AbortController();
        loadchats(controller.signal);
        return () => controller.abort();
    }, []);

        const normalizedSearch = searchtext.trim().toLowerCase();
        const packageOrder = ["Expired", "Ruby", "Emerald", "Diamond", "Platinum", "Gold", "Silver", "Bronze", "Unknown"];

        function normalizePackage(packageName) {
            const normalizedPackage = String(packageName || "").trim();
            if (!normalizedPackage) {
                return "Unknown";
            }

            return normalizedPackage.charAt(0).toUpperCase() + normalizedPackage.slice(1).toLowerCase();
        }

        function togglePackageVisibility(packageName) {
            setVisiblePackages((previousPackages) => ({
                ...previousPackages,
                [packageName]: !previousPackages[packageName]
            }));
        }

        const packageSections = packageOrder
            .map((packageName) => {
                const packageProfiles = activatedprofiles
                    .filter((item) => normalizePackage(item.package1) === packageName)
                    .filter((item) => {
                        if (!item.fullname1) {
                            return false;
                        }

                        if (!normalizedSearch) {
                            return true;
                        }

                        return item.fullname1.toLowerCase().includes(normalizedSearch);
                    })
                    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

                return {
                    packageName,
                    packageProfiles
                };
            });

        function hasRamzyProfile(item) {
            return Object.prototype.hasOwnProperty.call(item || {}, "ramzy");
        }

        function profileCardClass(item) {
            return hasRamzyProfile(item)
                ? "bg-purple-800 text-white w-full flex flex-col rounded-lg p-3 my-2 border border-purple-300"
                : "bg-black text-white w-full flex flex-col rounded-lg p-3 my-2";
        }

        function renderProfileCard(item, index) {
            if (!item.fullname1) {
                console.log("No fullname1 for item:", item);
                return null;
            }

            return (
                <div className={profileCardClass(item)} key={item.EMAIL || `${item.fullname1}-${index}`}>
                    <div className="flex flex-col justify-center items-center">
                        <SmartImageComponent id="Profile picture" cssclasses="w-8 h-8 rounded-full" src={"/profilepic/1?EMAIL="+item.EMAIL}/>
                        <p>{item.fullname1}</p>
                        <p>{item.EMAIL}</p>

                        <Link className="bg-white text-black w-full flex flex-col rounded-sm p-3" to={"/sirri_api/chat/"+item.EMAIL}>
                            See Messages
                        </Link>

                        <Link className="bg-white text-black w-full flex flex-col rounded-sm p-3 mt-3" to={"/sirri_api/chatasman/"+item.EMAIL}>
                            Message As Man
                        </Link>
                    </div>
                </div>
            );
        }

        return (
            <div className="flex flex-col items-center justify-center w-full">
                <div className="w-full md:w-1/2 lg:w-1/3 mb-4">
                    <input
                        className="bg-gray-300 p-2 rounded-lg w-full"
                        type="text"
                        placeholder="Search for a profile"
                        value={searchtext}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </div>


                {loading ? <Loader/> : null}
                <button className='bg-black p-3 w-full mt-4' onClick={() => setAllProfilesVisible(!allProfilesVisible)}>
                    <p className="text-white text-2xl mb-3 text-center">
                        {allProfilesVisible ? "HIDE" : "SHOW"} All Profiles (click)
                    </p>
                    <p className="text-white text-xs mb-3 text-center">Everyone regardless of package.</p>
                </button>

                {allProfilesVisible
                    ? (
                        (() => {
                            const filteredAllProfiles = activatedprofiles
                                .filter((item) => {
                                    if (!item.fullname1) {
                                        return false;
                                    }

                                    if (!normalizedSearch) {
                                        return true;
                                    }

                                    return item.fullname1.toLowerCase().includes(normalizedSearch);
                                })
                                .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

                            return (
                                <>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
                                        {filteredAllProfiles.map((item, index) => renderProfileCard(item, index))}
                                    </div>
                                    {filteredAllProfiles.length === 0 && (
                                        <p className="text-white text-center mt-4">No profiles found.</p>
                                    )}
                                </>
                            );
                        })()
                    )
                    : null
                }

                {!loading ? packageSections.map((section) => {
                    const packageName = section.packageName;
                    const packageProfiles = section.packageProfiles;
                    const packageVisible = Boolean(visiblePackages[packageName]);

                    return (
                        <React.Fragment key={packageName}>
                            <button className='bg-black p-3 w-full mt-4' onClick={() => togglePackageVisibility(packageName)}>
                                <p className="text-white text-2xl mb-3 text-center">
                                    {packageVisible ? "HIDE" : "SHOW"} People on {packageName} (click)
                                </p>
                                <p className="text-white text-xs mb-3 text-center">Only {packageName} package profiles.</p>
                            </button>

                            {packageVisible
                                ? (
                                    <>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
                                            {packageProfiles.map((item, index) => renderProfileCard(item, index))}
                                        </div>
                                        {packageProfiles.length === 0 && (
                                            <p className="text-white text-center mt-4">No profiles found.</p>
                                        )}
                                    </>
                                )
                                : null
                            }
                        </React.Fragment>
                    );
                }) : null}

                <button className='bg-black p-3 w-full mt-4' onClick={()=>setNonMessagedVisible(!nonMessagedVisible)}>
                    <p className="text-white text-2xl mb-3 text-center">
                        {nonMessagedVisible ? "HIDE" : "SHOW"} Non Messaged (click)
                    </p>
                    <p className="text-white text-xs mb-3 text-center">Everyone who has never been messaged.</p>
                </button>

                {nonMessagedVisible
                    ? <>
                        {loading ? <Loader/>
                            : (() => {
                                const filteredNonMessaged = activatedprofiles
                                    .filter((item) => item.last_messaged_timestamp === undefined)
                                    .filter((item) => {
                                        if (!item.fullname1) {
                                            return false;
                                        }

                                        if (!normalizedSearch) {
                                            return true;
                                        }

                                        return item.fullname1.toLowerCase().includes(normalizedSearch);
                                    })
                                    .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

                                return (
                                    <>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-1">
                                            {filteredNonMessaged.map((item, index) => (
                                                <div className={profileCardClass(item)} key={item.EMAIL || `${item.fullname1}-${index}`}>
                                                    <div className="flex flex-col justify-center items-center">
                                                        <SmartImageComponent id="Profile picture" cssclasses="w-8 h-8 rounded-full" src={"/profilepic/1?EMAIL="+item.EMAIL}/>
                                                        <p>{item.firstname1} {item.middlename1} {item.lastname1}</p>
                                                        <p>{item.EMAIL}</p>

                                                        <Link className="bg-white text-black w-full flex flex-col rounded-sm p-3" to={"/sirri_api/chat/"+item.EMAIL}>
                                                            See Messages
                                                        </Link>

                                                        <Link className="bg-white text-black w-full flex flex-col rounded-sm p-3 mt-3" to={"/sirri_api/chatasman/"+item.EMAIL}>
                                                            Message As Man
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {filteredNonMessaged.length === 0 && (
                                            <p className="text-white text-center mt-4">No profiles found.</p>
                                        )}
                                    </>
                                );
                            })()
                        }
                    </>
                    : null
                }
            </div>
        )
}

export function ChatInterface({womandata, male, chatdata, gender, callSignal = 0}) {
    const [showExpiredAccountModal, setShowExpiredAccountModal] = React.useState(false)
    const [specificchatdata, setSpecificChatdata] = React.useState({messages:[]})
    const [loading, setLoading] = React.useState(true)
    const [message, setMessage] = React.useState("")
    const [isUploadingVideo, setIsUploadingVideo] = React.useState(false)
    const [isUploadingImage, setIsUploadingImage] = React.useState(false)
    const [isSendingMessage, setIsSendingMessage] = React.useState(false)
    const messagesEndRef = React.useRef(null)
    const videoInputRef = React.useRef(null)
    const imageInputRef = React.useRef(null)
    const callSoundIntervalRef = React.useRef(null)
    const chatViewTrackingRef = React.useRef(null)
    const [isCallingOverlayVisible, setIsCallingOverlayVisible] = React.useState(false)
    
    const thegender = gender || "Female";
    const senderPackage = String(
        (thegender === "Female" ? womandata?.package1 : male?.package1)
        || womandata?.package1
        || male?.package1
        || ""
    ).trim().toUpperCase();
    const recipientPackage = String(
        (thegender === "Female" ? male?.package1 : womandata?.package1)
        || male?.package1
        || womandata?.package1
        || ""
    ).trim().toUpperCase();
    const canSendVideoMessage = videoEnabledPackages.has(senderPackage);
    const canInitiateCall = canInitiateCallByPackage(senderPackage);

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);

    console.log("Woman data", womandata)

    function loadchat(signal) {
        console.log("All the chat data ever:", chatdata)
        console.log("The dude: ", male)

        // CHecking if its a list.
        const url = "/api/getaveryspecificchat"
        const formData = new FormData();
        
        formData.append('id', womandata.__id)
        formData.append('name', male.fullname1)
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
            signal
        };
        
        postData(url, formData, config).then((data) => {
            console.log("Response getting chats:", data);
            if (data.responsecode === 200) {
                const trackingContext = chatTrackingContext({ womandata, male, gender: thegender, senderPackage });
                trackEvent('chat_loaded', trackingContext)
                startTimedBridgeEvent(chatViewTrackingRef, 'chat_view_duration', trackingContext);
                setSpecificChatdata(data.chats_data)
                setLoading(false)
            } else if (data.responsecode === 302) {
                const trackingContext = chatTrackingContext({ womandata, male, gender: thegender, senderPackage });
                trackEvent('chat_opened', { ...trackingContext, state: 'empty' })
                startTimedBridgeEvent(chatViewTrackingRef, 'chat_view_duration', trackingContext);
                setSpecificChatdata({messages:[]})
                setLoading(false)  
            } else {
                trackEvent('chat_load_failed')
                alert("You have reached the limit of bachelor contacts your package allows.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });
    }

    function deleteMessage(index) {
        trackEvent('message_delete_clicked')
        if (!window.confirm('Delete this message?')) return;
        const url = '/api/delete_message';
        const formData = new FormData();
        formData.append('id', womandata.__id ? womandata.__id : params.get('id'));
        formData.append('name', male.fullname1);
        formData.append('index', index);
        postData(url, formData).then((data) => {
            if (data.responsecode === 200) {
                trackEvent('message_deleted')
                const msgs = [...specificchatdata.messages];
                msgs.splice(index, 1);
                setSpecificChatdata({...specificchatdata, messages: msgs});
            } else {
                alert('Could not delete message');
            }
        }).catch((err) => {
            console.log('Error deleting message: ', err);
        });
    }

    function onSend (messageOverride = null) {
        if (isSendingMessage) {
            return;
        }
        const textToSend = messageOverride ?? message;
        if (!textToSend || !String(textToSend).trim()) {
            return;
        }

        const url = '/api/send_message';
        const formData = new FormData();
        
        formData.append('message', textToSend);
        formData.append('name', male.fullname1);
        if (womandata.nothing === undefined && womandata) {
            formData.append('woman', JSON.stringify(womandata))
        } else {
            console.log("It's off")
            formData.append('woman', JSON.stringify({nothing:specificchatdata.girl_pic}))
        }
        

        if (womandata.__id) {
            formData.append('ip', womandata.__id);
        } else {
            formData.append('ip', params.get('id'));
        }

        if (thegender==="Male") {
            formData.append('womanname', 'test')
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        console.log("The formdata before submitting: ", formData)
        var holdthis = specificchatdata
        setSpecificChatdata(holdthis)
        trackEvent('message_send_pressed', chatTrackingContext({ womandata, male, gender: thegender, senderPackage }))
        setIsSendingMessage(true)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                trackEvent(isCallInitiatedMessage(textToSend) ? 'chat_call_initiated_message_sent' : 'message_sent', chatTrackingContext({ womandata, male, gender: thegender, senderPackage }))
                if (thegender==="Female") {
                    holdthis.messages.push({"Girl Sent":{"message":textToSend, 'delivered':true}})
                } else {
                    holdthis.messages.push({"Guy Sent":{"message":textToSend, 'delivered': true}})
                }
                
                setSpecificChatdata(holdthis)
                setMessage("")
                postData('/api/sirri_api/increment_message_count', {})
            } else if (data.responsecode == 602){
                trackEvent('chat_blocked_by_package', { code: 602, package: senderPackage })
                alert("To contact this bachelor, you would need to be on a package similar to or higher than his. Contact WhatsApp support to guide you on the matter of upgrading your account.")
                setMessage("")
                setLoading(false)
            } else if (data.responsecode == 403){
                trackEvent('chat_blocked_by_package', { code: 403, package: senderPackage })
                alert("You have reached the limit of men you can message on your account. To message any more, contact WhatsApp support to guide you on the matter of upgrading your account.")
                setMessage("")
                setLoading(false)
            } else if (data.responsecode == 706) {
                const optionchosen = confirm("The person you are about to text is on a package below yours, thus they will not be able to respond to your message without upgrading. Do you wish to proceed:")
                if (optionchosen) {
                    trackEvent('chat_lower_package_confirmed')
                    formData.append('confirmsamepackage', 'true')
                    return postData(url, formData, config).then((data) => {
                        if (data.responsecode === 200) {
                            if (thegender==="Female") {
                                holdthis.messages.push({"Girl Sent":{"message":textToSend, 'delivered':true}})
                            } else {
                                holdthis.messages.push({"Guy Sent":{"message":textToSend, 'delivered': true}})
                            }
                            
                            setSpecificChatdata(holdthis)
                            setMessage("")
                            postData('/api/sirri_api/increment_message_count', {})
                        } else if (data.responsecode == 602){
                            alert("To contact this bachelor, you would need to be on a package similar to or higher than his. Contact WhatsApp support to guide you on the matter of upgrading your account.")
                            setMessage("")
                            setLoading(false)
                        } else if (data.responsecode == 403){
                            alert("You have reached the limit of men you can message on your account. To message any more, contact WhatsApp support to guide you on the matter of upgrading your account.")
                            setMessage("")
                            setLoading(false)
                        } else if (data.responsecode == 1000){
                            setShowExpiredAccountModal(true)
                            setLoading(false)
                        }
                    }).catch((err) => {
                        console.log("Error in setProfiledataSubmit: ", err);
                        throw err;
                    });
                }
            } else if (data.responsecode == 1000){
                setShowExpiredAccountModal(true)
                setLoading(false)
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        }).finally(() => {
            setIsSendingMessage(false)
        });
    }

    function triggerVideoSelect() {
        if (isUploadingVideo) {
            return;
        }
        if (!canSendVideoMessage) {
            trackEvent('video_blocked_by_package', { package: senderPackage })
            alert("Video message feature is available on Diamond, Emerald, Ruby and Sapphire packages. To access video message feature, please contact WhatsApp support to guide you on the matter of upgrading your account.");
            return;
        }
        trackEvent('chat_video_select_pressed', { package: senderPackage })
        videoInputRef.current?.click();
    }

    function stopCallingSound() {
        if (callSoundIntervalRef.current) {
            clearInterval(callSoundIntervalRef.current);
            callSoundIntervalRef.current = null;
        }
    }

    function playCallTone() {
        const context = getCallAudioContext();
        if (!context) {
            return;
        }
        if (context.state === "suspended") {
            context.resume();
        }

        const oscillator = context.createOscillator();
        const gainNode = context.createGain();
        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(880, context.currentTime);
        gainNode.gain.setValueAtTime(0.0001, context.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.15, context.currentTime + 0.03);
        gainNode.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.35);
        oscillator.connect(gainNode);
        gainNode.connect(context.destination);
        oscillator.start();
        oscillator.stop(context.currentTime + 0.4);
    }

    function startCallingSound() {
        stopCallingSound();
        playCallTone();
        callSoundIntervalRef.current = setInterval(playCallTone, 900);
    }

    function startCallAttemptOverlay() {
        trackEvent('chat_call_pressed', { package: senderPackage })
        setIsCallingOverlayVisible(true);
        startCallingSound();
    }

    function hangUpCall() {
        trackEvent('chat_call_hangup_clicked')
        stopCallingSound();
        setIsCallingOverlayVisible(false);
        onSend(CALL_INITIATED_MESSAGE);
    }

    async function onVideoSelected(event) {
        const selectedFile = event.target.files && event.target.files[0];
        if (!selectedFile) {
            return;
        }

        trackEvent('chat_video_selected', { package: senderPackage })
        trackEvent('chat_video_selected', { package: senderPackage })
        setIsUploadingVideo(true);
        try {
            const uploadFormData = new FormData();
            uploadFormData.append("video", selectedFile);
            const uploadResponse = await postData("/api/upload_chat_video", uploadFormData, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            });

            if (!uploadResponse || uploadResponse.responsecode !== 200 || !uploadResponse.video_url) {
                throw new Error("Video upload failed");
            }

            trackEvent('chat_video_uploaded', { package: senderPackage })
            trackEvent('chat_video_uploaded', { package: senderPackage })
            onSend(uploadResponse.video_url);
        } catch (error) {
            console.error("Error uploading video:", error);
            alert("The video was not uploaded.");
        } finally {
            if (event.target) {
                event.target.value = "";
            }
            setIsUploadingVideo(false);
        }
    }

    function triggerImageSelect() {
        if (isUploadingImage) {
            return;
        }
        trackEvent('chat_image_select_pressed')
        trackEvent('chat_image_select_pressed')
        imageInputRef.current?.click();
    }

    async function onImageSelected(event) {
        const selectedFile = event.target.files && event.target.files[0];
        if (!selectedFile) {
            return;
        }

        trackEvent('chat_image_selected')
        trackEvent('chat_image_selected')
        setIsUploadingImage(true);
        try {
            const imageUrl = await uploadFile(selectedFile);
            trackEvent('chat_image_uploaded')
            onSend(imageUrl);
        } catch (error) {
            console.error("Error uploading image:", error);
            alert("The image was not uploaded.");
        } finally {
            if (event.target) {
                event.target.value = "";
            }
            setIsUploadingImage(false);
        }
    }

    React.useEffect(() => {
        const controller = new AbortController();
        loadchat(controller.signal);
        return () => controller.abort();
    }, []);

    React.useEffect(() => {
        const handlePageHide = () => finishTimedBridgeEvent(chatViewTrackingRef, 'pagehide');
        window.addEventListener('pagehide', handlePageHide);
        return () => {
            window.removeEventListener('pagehide', handlePageHide);
            finishTimedBridgeEvent(chatViewTrackingRef, 'unmount');
        };
    }, []);

    React.useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [specificchatdata.messages]);

    const lastHandledCallSignalRef = React.useRef(callSignal);

    React.useEffect(() => {
        if (callSignal <= 0) {
            lastHandledCallSignalRef.current = callSignal;
            return;
        }

        if (callSignal === lastHandledCallSignalRef.current) {
            return;
        }

        lastHandledCallSignalRef.current = callSignal;

        if (!canInitiateCall) {
            alert("To call this bachelor, you would need to be on the sapphire package. Contact WhatsApp support to guide you on the matter of upgrading your account.");
            return;
        }

        startCallAttemptOverlay();
    }, [callSignal, canInitiateCall]);

    React.useEffect(() => {
        return () => {
            stopCallingSound();
        };
    }, []);

    return (
        <div className="ees-chat-interface container mx-auto shadow-lg rounded-sm h-[80vh] flex flex-col">
            <ExpiredAccountModal show={showExpiredAccountModal} onClose={() => setShowExpiredAccountModal(false)} />
            <style>{`
                .ees-chat-interface{--ink:#171411;--ink2:#625951;--paper:#f6f1e9;--paper2:#fffaf3;--wine:#3a1a22;--wine2:#512430;--gold:#bd9154;--gold2:#e4c79d;--line:rgba(23,20,17,.10);border-radius:22px;overflow:hidden;background:var(--paper2);box-shadow:none}
                .ees-chat-interface .ees-chat-frame{background:linear-gradient(180deg,rgba(255,250,243,.96),rgba(246,241,233,.92));border:1px solid rgba(189,145,84,.18);border-radius:20px;overflow:hidden}
                .ees-chat-interface .ees-chat-scroll{padding:16px;background:radial-gradient(circle at 0 0,rgba(228,199,157,.18),transparent 32%),var(--paper)}
                .ees-chat-interface .ees-chat-compose{background:rgba(255,250,243,.94);border-top:1px solid rgba(189,145,84,.24);gap:8px;padding:12px}
                .ees-chat-interface .ees-chat-textarea{background:#fffaf3;border:1px solid rgba(189,145,84,.28);color:var(--ink);border-radius:16px;outline:none;box-shadow:inset 0 1px 0 rgba(255,255,255,.8)}
                .ees-chat-interface .ees-chat-textarea:focus{border-color:rgba(189,145,84,.62);box-shadow:0 0 0 3px rgba(189,145,84,.14)}
                .ees-chat-interface .ees-chat-action{border:1px solid rgba(189,145,84,.32);background:linear-gradient(135deg,#fffaf3,#f2e4cc);color:var(--wine);border-radius:15px;min-width:44px;font-weight:700}
                .ees-chat-interface .ees-chat-send{background:linear-gradient(135deg,var(--wine2),var(--wine));color:#fff;border-color:transparent}
            `}</style>
            {isCallingOverlayVisible
                ? <div className="fixed inset-0 z-[100] bg-black/90 flex flex-col items-center justify-center text-white">
                    <div className="h-24 w-24 rounded-full border-4 border-green-500 animate-ping mb-4"></div>
                    <div className="h-24 w-24 rounded-full border-4 border-green-500 absolute"></div>
                    <p className="text-2xl font-semibold mt-6">Calling {turntoacronym(male?.fullname1 || "...")}</p>
                    <p className="mt-2 text-lg animate-pulse">Ringing...</p>
                    <button
                        className="mt-6 bg-red-600 hover:bg-red-700 text-white rounded-full px-6 py-3 font-semibold"
                        onClick={hangUpCall}
                    >
                        Hang Up
                    </button>
                  </div>
                : null
            }
            <div className="ees-chat-frame flex flex-row justify-between flex-1">
                <div className="w-full flex flex-col justify-between h-full">
                    <div className="ees-chat-scroll flex flex-col overflow-y-auto flex-1">
                        {loading ? <Loader/>
                            : <>
                                {specificchatdata.messages.map(function(item, index) {
                                    if (item["Guy Sent"]) {
                                        return <MansMessage text={item["Guy Sent"].message} male={male} key={index} isOutgoing={false} lastmessage={index === specificchatdata.messages.length-1} delivered={item["Guy Sent"].delivered || true}/>
                                    } else {
                                        return <WomansMessage text={item["Girl Sent"].message} womandata={womandata} key={index} isOutgoing={true} onClick={() => deleteMessage(index)} lastmessage={index === specificchatdata.messages.length-1} delivered={item["Girl Sent"].delivered || true}/>
                                    }
                                })}
                                <div ref={messagesEndRef} />
                            </>
                        }
                    </div>
                    <div className="ees-chat-compose sticky bottom-0 flex items-center">
                        <ChatUploadMenu
                            onImageSelect={triggerImageSelect}
                            onVideoSelect={triggerVideoSelect}
                            isUploadingImage={isUploadingImage}
                            isUploadingVideo={isUploadingVideo}
                            buttonClassName="ees-chat-action px-2 py-2 text-base leading-none"
                            menuClassName="text-gray-900"
                        />
                        <textarea
                            className="ees-chat-textarea flex-grow py-2 px-3 resize-y"
                            placeholder="type your message here..."
                            rows={2}
                            onChange={(e) => setMessage(e.target.value)}
                            value={message}
                        />
                        <input
                            ref={videoInputRef}
                            type="file"
                            accept="video/*"
                            className="hidden"
                            onChange={onVideoSelected}
                        />
                        <input
                            ref={imageInputRef}
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={onImageSelected}
                        />
                        <button
                            className="ees-chat-action ees-chat-send px-2 py-2 disabled:opacity-60 disabled:cursor-not-allowed"
                            onClick={() => onSend()}
                            style={{borderColor: "black!important"}}
                            disabled={isSendingMessage}
                            aria-label="Send message"
                            title="Send message"
                        >
                            {isSendingMessage ? "⏳" : "📨"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export function ChatInterfaceMan({
    womandata, male, 
    chatdata, gender, 
    activation = false,
    showCopyOptions = true,
    callSignal = 0
}) {
    const [specificchatdata, setSpecificChatdata] = React.useState({messages:[]})
    const [loading, setLoading] = React.useState(true)

    const [showcoldopenings, setShowColdOpening] = React.useState(false)

    const [message, setMessage] = React.useState("")
    const [isUploadingVideo, setIsUploadingVideo] = React.useState(false)
    const [isUploadingImage, setIsUploadingImage] = React.useState(false)
    const [isSendingMessage, setIsSendingMessage] = React.useState(false)
    const [isCallingOverlayVisible, setIsCallingOverlayVisible] = React.useState(false)
    const messagesEndRef = React.useRef(null)
    const videoInputRef = React.useRef(null)
    const imageInputRef = React.useRef(null)
    const callSoundIntervalRef = React.useRef(null)
    const chatViewTrackingRef = React.useRef(null)

    const [generatedresponses, setGeneratedResponses] = React.useState([])
    const [showgeneratedresponses, setShowGeneratedResponses] = React.useState(false)
    const [generatedresponsesloading, setGeneratedResponsesLoading] = React.useState(false)
    const [showQuestionPrompts, setShowQuestionPrompts] = React.useState(false)
    const [showPipelineAnswers, setShowPipelineAnswers] = React.useState(false)
    const [copiedMessageIndex, setCopiedMessageIndex] = React.useState(null)

    const questionPrompts = [
        "What does a relationship feel like when you feel truly safe and valued?",
        "When you imagine being deeply cared for, what does that look like in everyday life?",
        "What qualities in a man make you feel respected rather than just admired?",
        "What kind of connection makes you feel calm, not anxious or uncertain?",
        "What small gestures mean the most to you in a relationship?",
        "When life gets stressful, how do you like a partner to show up for you?",
        "What makes you feel emotionally close to someone?",
        "What does \"being chosen\" mean to you personally?",
        "What kind of energy or presence draws you toward a man?",
        "What would make meeting someone feel natural and right for you?",
        "What do you hope love feels like this time around?"
    ]
    
    const thegender = gender || "Female";
    const senderPackage = String(male?.package1 || womandata?.package1 || "").trim().toUpperCase();
    const recipientPackage = String(womandata?.package1 || male?.package1 || "").trim().toUpperCase();
    const canSendVideoMessage = videoEnabledPackages.has(senderPackage);
    const canInitiateCall = canInitiateCallByPackage(senderPackage);

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const chatIdentityReady = canSendAsMan(male, womandata)

    function stopCallingSound() {
        if (callSoundIntervalRef.current) {
            clearInterval(callSoundIntervalRef.current);
            callSoundIntervalRef.current = null;
        }
    }

    function playCallTone() {
        const context = getCallAudioContext();
        if (!context) {
            return;
        }
        if (context.state === "suspended") {
            context.resume();
        }

        const oscillator = context.createOscillator();
        const gainNode = context.createGain();
        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(880, context.currentTime);
        gainNode.gain.setValueAtTime(0.0001, context.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.15, context.currentTime + 0.03);
        gainNode.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.35);
        oscillator.connect(gainNode);
        gainNode.connect(context.destination);
        oscillator.start();
        oscillator.stop(context.currentTime + 0.4);
    }

    function startCallingSound() {
        stopCallingSound();
        playCallTone();
        callSoundIntervalRef.current = setInterval(playCallTone, 900);
    }

    function startCallAttempt() {
        setIsCallingOverlayVisible(true);
        startCallingSound();
    }

    function hangUpCall() {
        stopCallingSound();
        setIsCallingOverlayVisible(false);
        onSend(CALL_INITIATED_MESSAGE);
    }

    function sendCallInitiatedMessage() {
        if (!chatIdentityReady || isSendingMessage) {
            return;
        }
        if (!canInitiateCall) {
            alert("To call this bachelor, you would need to be on the sapphire package. Contact WhatsApp support to guide you on the matter of upgrading your account.");
            return;
        }
        onSend(CALL_INITIATED_MESSAGE);
    }

    function loadchat(signal) {
        console.log("All the chat data ever:", chatdata)
        console.log("The dude: ", male)

        // CHecking if its a list.
        const url = "/api/getaveryspecificchat"
        const formData = new FormData();
        
        formData.append('id', womandata.__id)
        formData.append('name', male.fullname1)
        formData.append('woman', JSON.stringify(womandata))

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
            signal
        };
        
        postData(url, formData, config).then((data) => {
            console.log("Response getting chats:", data);
            if (data.responsecode === 200) {
                const trackingContext = chatTrackingContext({ womandata, male, gender: thegender, senderPackage });
                trackEvent('admin_chat_loaded', trackingContext)
                startTimedBridgeEvent(chatViewTrackingRef, 'admin_chat_view_duration', trackingContext);
                setSpecificChatdata(data.chats_data)
                setLoading(false)
            } else if (data.responsecode === 302) {
                const trackingContext = chatTrackingContext({ womandata, male, gender: thegender, senderPackage });
                trackEvent('admin_chat_opened', { ...trackingContext, state: 'empty' })
                startTimedBridgeEvent(chatViewTrackingRef, 'admin_chat_view_duration', trackingContext);
                setSpecificChatdata({messages:[]})
                setLoading(false)  
            } else {
                alert("You have reached the limit of bachelor contacts your package allows.")
            }
            // generatesomeresponses()
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });
    }

    function generatesomeresponses() {
        trackEvent('admin_ai_response_generate_pressed')
        trackEvent('admin_ai_response_generate_pressed')
        setGeneratedResponsesLoading(true)
        

        // CHecking if its a list.
        const url = "/api/sirri_api/generate_suggestions"
        const formData = new FormData();
        
        formData.append('__id', womandata.__id)
        formData.append('male', male.fullname1)

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        
        postData(url, formData, config).then((data) => {
            console.log("Response getting chats:", data);
            if (data.responsecode === 200) {
                trackEvent('admin_ai_response_generated')
                trackEvent('admin_ai_response_generated')
                setGeneratedResponses(data.generatedresponses)
                setGeneratedResponsesLoading(false)
                setShowGeneratedResponses(true)
            } else {
                alert("Something has gone wrong with the ai integration. Contact Support.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });
    }

    function deleteMessage(index) {
        if (!window.confirm('Delete this message?')) return;
        const url = '/api/delete_message';
        const formData = new FormData();
        formData.append('id', womandata.__id ? womandata.__id : params.get('id'));
        formData.append('name', male.fullname1);
        formData.append('index', index);
        postData(url, formData).then((data) => {
            if (data.responsecode === 200) {
                const msgs = [...specificchatdata.messages];
                msgs.splice(index, 1);
                setSpecificChatdata({...specificchatdata, messages: msgs});
            } else {
                alert('Could not delete message');
            }
        }).catch((err) => {
            console.log('Error deleting message: ', err);
        });
    }

    function onSend (messageOverride = null) {
        if (!chatIdentityReady) {
            return
        }
        if (isSendingMessage) {
            return;
        }
        const textToSend = messageOverride ?? message;
        if (!textToSend || !String(textToSend).trim()) {
            return;
        }

        const url = '/api/send_message_';
        const formData = new FormData();
        
        formData.append('message', textToSend);
        formData.append('name', male.fullname1);
        formData.append('woman', JSON.stringify(womandata))

        if (womandata.__id) {
            formData.append('ip', womandata.__id);
        } else {
            formData.append('ip', params.get('id'));
        }

        if (thegender==="Male") {
            formData.append('womanname', 'test')
        }

        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };

        console.log("The formdata before submitting: ", formData)
        trackEvent('admin_message_send_as_man_pressed', chatTrackingContext({ womandata, male, gender: thegender, senderPackage }))
        setIsSendingMessage(true)
        postData(url, formData, config).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                trackEvent(isCallInitiatedMessage(textToSend) ? 'admin_call_initiated_message_sent' : 'admin_message_sent_as_man', chatTrackingContext({ womandata, male, gender: thegender, senderPackage }))
                console.log('HU!!')
                var holdthis = specificchatdata
                console.log(holdthis)
                
                if (thegender==="Female") {
                    holdthis.messages.push({"Girl Sent":{"message":textToSend}})
                } else {
                    holdthis.messages.push({"Guy Sent":{"message":textToSend}})
                }
                
                setSpecificChatdata(specificchatdata)
                setMessage("")
                postData('/api/sirri_api/increment_message_count', {})
                if (isCallInitiatedMessage(textToSend)) {
                    alert("Call sent.");
                }
            } else if (data.responsecode === 602) {
                trackEvent('chat_blocked_by_package', { code: 602, package: senderPackage })
                alert("You cannot message this woman on your current package.")
            } else if (data.responsecode === 403) {
                alert("You have reached the limit of bachelor contacts your package allows.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        }).finally(() => {
            setIsSendingMessage(false)
        });
    }

    function triggerVideoSelect() {
        if (isUploadingVideo || !chatIdentityReady) {
            return;
        }
        if (!canSendVideoMessage) {
            trackEvent('video_blocked_by_package', { package: senderPackage })
            alert("You cannot message this woman on your current package.");
            return;
        }
        trackEvent('chat_video_select_pressed', { package: senderPackage })
        videoInputRef.current?.click();
    }

    async function onVideoSelected(event) {
        const selectedFile = event.target.files && event.target.files[0];
        if (!selectedFile) {
            return;
        }

        setIsUploadingVideo(true);
        try {
            const uploadFormData = new FormData();
            uploadFormData.append("video", selectedFile);
            const uploadResponse = await postData("/api/upload_chat_video", uploadFormData, {
                headers: {
                    "content-type": "multipart/form-data",
                },
            });

            if (!uploadResponse || uploadResponse.responsecode !== 200 || !uploadResponse.video_url) {
                throw new Error("Video upload failed");
            }

            onSend(uploadResponse.video_url);
        } catch (error) {
            console.error("Error uploading video:", error);
            alert("The video was not uploaded.");
        } finally {
            if (event.target) {
                event.target.value = "";
            }
            setIsUploadingVideo(false);
        }
    }

    function triggerImageSelect() {
        if (isUploadingImage || !chatIdentityReady) {
            return;
        }
        imageInputRef.current?.click();
    }

    async function onImageSelected(event) {
        const selectedFile = event.target.files && event.target.files[0];
        if (!selectedFile) {
            return;
        }

        setIsUploadingImage(true);
        try {
            const imageUrl = await uploadFile(selectedFile);
            trackEvent('chat_image_uploaded')
            onSend(imageUrl);
        } catch (error) {
            console.error("Error uploading image:", error);
            alert("The image was not uploaded.");
        } finally {
            if (event.target) {
                event.target.value = "";
            }
            setIsUploadingImage(false);
        }
    }

    React.useEffect(() => {
        const controller = new AbortController();
        loadchat(controller.signal);
        return () => controller.abort();
    }, []);

    React.useEffect(() => {
        const handlePageHide = () => finishTimedBridgeEvent(chatViewTrackingRef, 'pagehide');
        window.addEventListener('pagehide', handlePageHide);
        return () => {
            window.removeEventListener('pagehide', handlePageHide);
            finishTimedBridgeEvent(chatViewTrackingRef, 'unmount');
        };
    }, []);

    React.useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [specificchatdata.messages]);

    const lastHandledCallSignalRef = React.useRef(callSignal);

    React.useEffect(() => {
        if (callSignal <= 0) {
            lastHandledCallSignalRef.current = callSignal;
            return;
        }

        if (callSignal === lastHandledCallSignalRef.current) {
            return;
        }

        lastHandledCallSignalRef.current = callSignal;

        if (!canInitiateCall) {
            alert("To call this bachelor, you would need to be on the sapphire package. Contact WhatsApp support to guide you on the matter of upgrading your account.");
            return;
        }

        startCallAttempt();
    }, [callSignal, canInitiateCall]);

    React.useEffect(() => {
        return () => {
            stopCallingSound();
        };
    }, []);

    const handleCopyMessage = async (text, index) => {
        try {
            await copyMessageToClipboard(text);
            setCopiedMessageIndex(index);
            window.setTimeout(() => {
                setCopiedMessageIndex((currentIndex) => currentIndex === index ? null : currentIndex);
            }, 1500);
        } catch (error) {
            console.error("Clipboard copy failed:", error);
            alert("Could not copy this message.");
        }
    };

    return (
        <div className="container mx-auto shadow-lg rounded-lg h-[80vh] flex flex-col">
            {isCallingOverlayVisible
                ? <div className="fixed inset-0 z-[100] bg-black/90 flex flex-col items-center justify-center text-white">
                    <div className="h-24 w-24 rounded-full border-4 border-green-500 animate-ping mb-4"></div>
                    <div className="h-24 w-24 rounded-full border-4 border-green-500 absolute"></div>
                    <p className="text-2xl font-semibold mt-6">Calling {turntoacronym(womandata?.fullname1 || "...")}</p>
                    <p className="mt-2 text-lg animate-pulse">Ringing...</p>
                    <button
                        className="mt-6 bg-red-600 hover:bg-red-700 text-white rounded-full px-6 py-3 font-semibold"
                        onClick={hangUpCall}
                    >
                        Hang Up
                    </button>
                  </div>
                : null
            }
            <div className="flex flex-col justify-center bg-white flex-1">

            <div className="w-full px-2 flex flex-col justify-between h-full">
                <div className="flex flex-col mt-5 overflow-y-auto flex-1">
                    {loading ? <Loader/>
                        : <>
                            {specificchatdata.messages.map(function(item, index) {
                                if (item["Guy Sent"]) {
                                    const guyMessage = item["Guy Sent"];
                                    const wasReadByWoman = Boolean(guyMessage?.read || guyMessage?.seen || guyMessage?.is_read);
                                    return (
                                        <MansMessage
                                            text={guyMessage.message}
                                            male={male}
                                            key={index}
                                            isOutgoing={true}
                                            onClick={() => deleteMessage(index)}
                                            showCopy={showCopyOptions}
                                            onCopy={(text) => handleCopyMessage(text, index)}
                                            copied={copiedMessageIndex === index}
                                            showReadStatus={true}
                                            read={wasReadByWoman}
                                        />
                                    );
                                } else {
                                    return <WomansMessage text={item["Girl Sent"].message} womandata={womandata} key={index} isOutgoing={false} showCopy={showCopyOptions} onCopy={(text) => handleCopyMessage(text, index)} copied={copiedMessageIndex === index}/>
                                }
                            })}
                            <div ref={messagesEndRef} />
                          </>
                    }
                </div>
                    <div class="flex flex-col items-center justify-center w-full">
                    <div className="flex flex-row space-x-2">
                            <button className="w-full bg-black rounded-lg p-2 text-white text-xs m-1" onClick={() => {setShowQuestionPrompts(!showQuestionPrompts);setShowPipelineAnswers(false)}}>
                                {showQuestionPrompts ? "HIDE" : "SHOW"} QUESTIONS
                            </button>
                            <button className="w-full bg-black rounded-lg p-2 text-white text-xs m-1" onClick={() => {setShowPipelineAnswers(!showPipelineAnswers);setShowQuestionPrompts(false)}}>
                                {showPipelineAnswers ? "HIDE" : "SHOW"} ENDING CONVERSATION
                            </button>
                        </div>
                    </div>
                    <div className="w-full flex flex-col justify-center items-center">

                        {showQuestionPrompts && (
                            <div className="text-white mt-2 w-full max-w-md">
                                {questionPrompts.map((prompt, index) => (
                                    <button
                                        className="w-full bg-black rounded-lg p-2 text-white text-xs m-1 border border-white text-left"
                                        key={index}
                                        onClick={() => setMessage(prompt)}
                                    >
                                        {prompt}
                                    </button>
                                ))}
                            </div>
                        )}

                        {showPipelineAnswers && (
                            <div className="text-white mt-2">
                                {endingconversations.map((item, index) => {
                                const key = Object.keys(item)[0];      // e.g., "Prenup A"
                                const value = item[key];               // e.g., "I require a prenup..."

                                return (
                                    <MansMessage
                                    text={key}                         // display the title as the message
                                    key={index}
                                    onClick={() => setMessage(value)}  // pass the sentence to setMessage
                                    hideimage={false}
                                    male={{ fullname1: "nothing" }}
                                    />
                                );
                                })}
                            </div>
                        )}
                    </div>
                </div>

                <div className="py-3 bg-gray-300 sticky bottom-0 flex space-x-2 items-center">
                    <ChatUploadMenu
                        onImageSelect={triggerImageSelect}
                        onVideoSelect={triggerVideoSelect}
                        isUploadingImage={isUploadingImage}
                        isUploadingVideo={isUploadingVideo}
                        disabled={!chatIdentityReady}
                        buttonClassName="bg-primary-600 text-black px-4 py-2 rounded-lg text-xl leading-none disabled:opacity-60 disabled:cursor-not-allowed"
                    />
                    <textarea
                        className="flex-grow bg-gray-300 py-2 px-2 rounded-xl resize-y"
                        placeholder="type your message here..."
                        rows={2}
                        onChange={(e) => setMessage(e.target.value)}
                        value={message}
                    />
                    <input
                        ref={videoInputRef}
                        type="file"
                        accept="video/*"
                        className="hidden"
                        onChange={onVideoSelected}
                    />
                    <input
                        ref={imageInputRef}
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={onImageSelected}
                    />
                    <button
                        className="bg-primary-600 text-black px-4 py-2 rounded-lg disabled:opacity-60 disabled:cursor-not-allowed"
                        onClick={() => onSend()}
                        disabled={!chatIdentityReady || isSendingMessage}
                        aria-label="Send message"
                        title="Send message"
                    >
                        {isSendingMessage ? "⏳" : "📨"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export function ChatManagerMenu({ chat, email }) {
    const [saving, setSaving] = React.useState(false)
    const [manager, setManager] = React.useState(chat.manager)
    const menuRef = React.useRef(null)

    async function setBot(kind) {
        if (saving) return
        setSaving(true)
        try {
            const endpoint = kind === 'hunter' ? 'set_hunter_bot' : 'set_boring_bot'
            const data = await postData(`/api/sirri_api/chats/${endpoint}`, {
                email,
                male: chat.male
            })
            if (!data || data.responsecode !== 200) {
                throw new Error(data?.message || 'Could not save chat manager.')
            }
            setManager(data.manager)
            if (menuRef.current) menuRef.current.open = false
        } catch (error) {
            alert(error.message || 'Could not save chat manager.')
        } finally {
            setSaving(false)
        }
    }

    return (
        <div className="flex justify-end items-center gap-2">
            {['Boringbot', 'Hunterbot'].includes(manager) && <span className="text-xs">{manager}</span>}
            <details ref={menuRef} className="relative">
                <summary className="cursor-pointer text-xl list-none px-2" aria-label={`Chat options for ${chat.male}`}>⋮</summary>
                <div className="absolute right-0 mt-2 w-40 rounded bg-white text-black shadow-lg z-10">
                    <button type="button" className="w-full px-3 py-2 text-left hover:bg-gray-200 disabled:opacity-50"
                        disabled={saving} onClick={() => setBot('boring')}>
                        {saving ? 'Saving…' : 'set boring bot'}
                    </button>
                    <button type="button" className="w-full px-3 py-2 text-left hover:bg-gray-200 disabled:opacity-50"
                        disabled={saving} onClick={() => setBot('hunter')}>
                        {saving ? 'Saving…' : 'set hunter bot'}
                    </button>
                </div>
            </details>
        </div>
    )
}

export function SpecificPersonsChat() {
    const { email } = useParams();

    const [chatdata, setChatData] = React.useState([])
    const [selectedchat, setSelectedChat] = React.useState([])
    const [loading, setLoading] = React.useState(true)

    const [maledata, maleData] = React.useState([])
    const [maleloading, setmaleLoading] = React.useState(false)

    const [femaledata, femaleData] = React.useState([])
    const [femaleloading, setfemaleLoading] = React.useState(false)

    const [individualchatvisible, setIndividualchatvisible] = React.useState(false)
    const [callSignal, setCallSignal] = React.useState(0)

    function loadprofile(url, setCallback, setLoadingCallback) {
        console.log(setLoadingCallback)
        postData(url, {}).then((data) => {
            
            console.log("With url: ", url)
            console.log(data);

            if (data.responsecode === 200) {
                setCallback(data.data)
                setLoadingCallback(false)
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((err) => {
            console.log("Error in setProfiledataSubmit: ", err);
            throw err;
        });
    }

    function messagePerson(item) {
        setmaleLoading(true)
        setfemaleLoading(true) 
        console.log('The mans name: ', item.male)
        const womenmenurl = `/api/getprofile/${Base64.encode(email)}`;
        const menurl = `/api/getprofile/${Base64.encode(item.male)}`;
        
        loadprofile(menurl, maleData, setmaleLoading)
        loadprofile(womenmenurl, femaleData, setfemaleLoading)
        
        setIndividualchatvisible(true)
        setSelectedChat(item)
    }

    function loadchats(signal) {
        const url = `/api/chats/responder/${email}`;

        fetchData(url, { signal }).then((data) => {
            console.log(data);
            if (data.responsecode === 200) {
                console.log("Here are all the chats: ", data.chats_data)
                setChatData(data.chats_data)
                setLoading(false)
            } else {
                alert("Something went wrong. Please contact support.")
            }
        }).catch((error) => {
            console.error("Error fetching auth codes:", error);
            throw error;
        });
    }

    React.useEffect(() => {
        const controller = new AbortController();
        loadchats(controller.signal);
        return () => controller.abort();
    }, []);

        return (
            <>
            {maleloading === false && femaleloading === false
                ? <GeneralModal 
                        showModal={individualchatvisible} maintitle={maledata.fullname1 || ""}
                        notdisableproceed={false} canceltext="Back"
                        setShowModal={setIndividualchatvisible}
                        lilbutton={true} lilbuttonlink={'/profilen/'+Base64.encode(maledata.fullname1) || ''}
                        lilbuttontext="View Profile"
                        middlebutton={true}
                        middlebuttontext="Call"
                        middlebuttonicon="📞"
                        onMiddleButtonClick={() => {
                            primeCallAudioFromUserGesture();
                            setCallSignal((prev) => prev + 1);
                        }}
                  >
                  <ChatInterfaceMan
                        womandata={femaledata}
                        male={maledata}
                        chatdata={selectedchat}
                        gender={"Male"}
                        showCopyOptions={true}
                        callSignal={callSignal}
                    />
                  </GeneralModal>
                : null
            }

            <div className="flex flex-col w-full">
                <Link className="bg-black text-white p-3 w-full flex flex-col rounded-lg" to="/sirri_api/chats">
                    <div className="flex flex-col justify-center items-center">
                        <p>BACK TO ALL CHATS</p>
                    </div>
                </Link>

                <Link className="bg-white text-black p-3 w-full flex flex-col rounded-lg my-2" to={"/profilen/"+Base64.encode(email)}>
                    <div className="flex flex-col justify-center items-center">
                        <p>VISIT PROFILE</p>
                    </div>
                </Link>
                
                <div className="my-3 flex flex-col bg-black p-3 justify-center items-center">
                    <SmartImageComponent id="Profile picture" cssclasses="w-32 h-32 rounded-full" src={"/profilepic/1?EMAIL="+email}/>
                    <p className="text-white text-xl">Chat Viewer for {loading ? null : Object.keys(chatdata).map((item) => <>{item}</>)}</p>
                </div>
                
                {loading 
                    ? <Loader />
                    :   <div className="grid grid-cols-2 md:grid-cols-3 gap-1">
                            {Object.keys(chatdata).map((item, index) => (
                                <>
                                    {chatdata[item].map((chatitem, chatindex) => (
                                        <div key={chatitem.male} className="bg-black text-white w-full flex flex-col rounded-lg p-4">
                                            <ChatManagerMenu chat={chatitem} email={email} />
                                            <button type="button" className="w-full flex flex-col justify-center items-center" onClick={() => messagePerson(chatitem)}>
                                                <SmartImageComponent id="Profile picture" cssclasses="w-8 h-8 rounded-full" src={chatitem.guys_pic}/>
                                                <p>{chatitem.female} - {chatitem.male}</p>
                                                <p>Messages: {chatitem.all_num_msg}</p>
                                                <WomansProfileBadge profile={chatitem} />
                                            </button>
                                        </div>
                                    ))}
                                </>
                            ))}
                        </div>
                }
            </div>
            </>
        )
}

export function SpecificPersonsChatAsMan() {
    function profileCardClass(item) {
        return Object.prototype.hasOwnProperty.call(item || {}, 'ramzy')
            ? "bg-purple-800 text-white w-full flex flex-col rounded-lg p-4 my-2 border border-purple-300"
            : "bg-black text-white w-full flex flex-col rounded-lg p-4 my-2";
    }
    const {email} = useParams();
    const routeRef = React.useRef(email);
    routeRef.current = email;
    const [search, setSearch] = React.useState('');
    const [selectedchat, setSelectedChat] = React.useState([]);
    const [maleName, setMaleName] = React.useState('');
    const [individualchatvisible, setIndividualchatvisible] = React.useState(false);
    const [callSignal, setCallSignal] = React.useState(0);
    const woman = useListingProfile(`/api/getprofile/${encodeURIComponent(Base64.encode(email))}`);
    const man = useListingProfile(maleName ? `/api/getprofile/${encodeURIComponent(Base64.encode(maleName))}` : null);
    const femaledata = woman.data;
    const maledata = man.data;
    const femaleloading = woman.loading;
    const direct = useMenListing({search, section: 'direct', womanEmail: email});
    const nonDirect = useMenListing({search, section: 'non_direct', womanEmail: email});
    const all = useMenListing({search, section: 'all', womanEmail: email});
    const directRef = useListingObserver(direct);
    const nonDirectRef = useListingObserver(nonDirect);
    const allRef = useListingObserver(all);
    React.useEffect(() => {
        routeRef.current = email;
        setMaleName('');
        setIndividualchatvisible(false);
        setSelectedChat([]);
        setCallSignal(0);
        return () => {routeRef.current = null;};
    }, [email]);
    function messagePerson(item) {
        setMaleName(item.fullname1);
        setIndividualchatvisible(true);
        setSelectedChat([]);
    }
    function startConversation(item) {
        const womansId = femaledata.__id
        if (!womansId) {
            alert("Woman profile not loaded yet.")
            return
        }
        postData('/api/sirri_api/aiconversations', {
            malename: item.fullname1,
            woman_email: email,
            woman_id: womansId
        }).then((data) => {
            if (data.responsecode === 200) {
                alert("Conversation started.")
            } else {
                alert("Failed to start conversation.")
            }
        }).catch((error) => {
            console.error("Error starting conversation:", error);
            alert("Failed to start conversation.")
        })
    }

    function duplicateProfile(item) {
        postData('/api/sirri_api/duplicate_men_profile', {
            EMAIL: item.EMAIL,
            fullname1: item.fullname1
        }).then((data) => {
            if (routeRef.current !== email) return;
            if (data.responsecode === 200) {
                alert(`Duplicated profile created: ${data.data.EMAIL}`)
                direct.refresh(); nonDirect.refresh(); all.refresh();
            } else {
                alert(data.message || "Failed to duplicate profile.")
            }
        }).catch((error) => {
            console.error("Error duplicating profile:", error)
            alert("Failed to duplicate profile.")
        })
    }

    function renderSection(title, listing, sentinel) {
        return <section aria-label={title}>
            <p className="text-white text-xl">{title}</p>
            <p className="text-white">Total in filter: {listing.total == null ? '—' : listing.total} · Loaded: {listing.profiles.length}</p>
            {listing.initialLoading && <Loader />}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-1">
                {listing.profiles.map(item => (
                    <div key={menProfileKey(item)} className={profileCardClass(item)}>
                        <div className="flex justify-end">
                            <details className="relative">
                                <summary className="cursor-pointer text-xl list-none">⋮</summary>
                                <div className="absolute right-0 mt-2 w-52 rounded bg-white text-black shadow-lg z-10">
                                    <button
                                        className="w-full px-3 py-2 text-left hover:bg-gray-200"
                                        onClick={() => startConversation(item)}
                                    >
                                        Start Conversation
                                    </button>
                                    <Link className="block w-full px-3 py-2 text-left hover:bg-gray-200" to={"/profilen/"+Base64.encode(item.fullname1)}>
                                        VISIT MANS PROFILE
                                    </Link>
                                    <button className="w-full px-3 py-2 text-left hover:bg-gray-200" onClick={() => messagePerson(item)}>
                                        Message
                                    </button>
                                    <button type="button" className="w-full px-3 py-2 text-left hover:bg-gray-200" onClick={() => duplicateProfile(item)}>
                                        Duplicate Profile
                                    </button>
                                    <button className="w-full px-3 py-2 text-left hover:bg-gray-200" onClick={() => messagePerson(item)}>
                                        Edit (doesnt work yet)
                                    </button>
                                </div>
                            </details>
                        </div>
                        <div className="flex flex-col justify-center items-center">
                            <SmartImageComponent id="Profile picture" cssclasses="w-8 h-8 rounded-full" src={"/profilepic/1?EMAIL="+encodeURIComponent(item.EMAIL)}/>

                            <p>{item.fullname1}</p>
                            <p>Package: {item.package1}</p>
                            <p>Age: {item.age1}</p>
                            <p>Country: {item.country1}</p>
                            <WomansProfileBadge profile={item} />
                        </div>
                    </div>
                ))}
            </div>
            {!listing.initialLoading && !listing.error && listing.total === 0 && <p className="text-white">No men found.</p>}
            {listing.loadingMore && <Loader />}
            {listing.error && <div role="alert" className="text-white">{listing.error} <button type="button" onClick={listing.retry}>Retry</button></div>}
            {listing.hasMore && !listing.error && <button type="button" className="my-2 px-4 py-2 bg-blue-500 text-white rounded"
                disabled={listing.initialLoading || listing.loadingMore} onClick={listing.loadMore}>Load more</button>}
            <div ref={sentinel} aria-hidden="true" className="h-1 w-full" />
        </section>;
    }
    return <>
        {individualchatvisible && (man.loading || woman.loading || man.error || woman.error) &&
            <GeneralModal showModal={true} maintitle="Loading chat profile" canceltext="Back" notdisableproceed={false} setShowModal={setIndividualchatvisible}>
                {(man.loading || woman.loading) && <Loader />}
                {man.error && <div role="alert">{man.error} <button type="button" onClick={man.retry}>Retry man's profile</button></div>}
                {woman.error && <div role="alert">{woman.error} <button type="button" onClick={woman.retry}>Retry woman's profile</button></div>}
            </GeneralModal>}
        {!man.loading && !woman.loading && !man.error && !woman.error && maleName &&
                <GeneralModal
                        showModal={individualchatvisible} maintitle={maledata.fullname1 || ""}
                        notdisableproceed={false} canceltext="Back"
                        setShowModal={setIndividualchatvisible}
                        lilbutton={true} lilbuttonlink={'/profilen/'+Base64.encode(maledata.fullname1) || ''}
                        lilbuttontext="View Profile"
                        middlebutton={true}
                        middlebuttontext="Call"
                        middlebuttonicon="📞"
                        onMiddleButtonClick={() => {
                            primeCallAudioFromUserGesture();
                            setCallSignal((prev) => prev + 1);
                        }}
                    >
                  <ChatInterfaceMan
                        womandata={femaledata}
                        male={maledata}
                        chatdata={selectedchat}
                        gender={"Male"}
                        callSignal={callSignal}
                    />
                  </GeneralModal>
        }
            <div className="flex flex-col">
                <div className='grid grid-cols-2'>
                <Link className="bg-black text-white text-sm p-3 w-full flex flex-col rounded-lg" to="/sirri_api/chats">
                    <div className="flex flex-col justify-center items-center">
                        <p>BACK TO ALL CHATS</p>
                    </div>
                </Link>

                <Link className="bg-black text-white p-3 text-sm w-full flex flex-col rounded-lg" to={"/profilen/"+Base64.encode(email)}>
                    <div className="flex flex-col justify-center items-center">
                        <p>VISIT WOMANS PROFILE</p>
                    </div>
                </Link>
                </div>
                
                <div className="my-3 flex flex-col bg-black p-3 justify-center items-center">
                    <SmartImageComponent id="Profile picture" cssclasses="h-16 w-auto" src={"/profilepic/1?EMAIL="+encodeURIComponent(email)}/>
                    <div className="flex flex-col items-center justify-center">
                        {femaleloading || woman.error
                            ? <p className="text-white text-sm">{"Texting as a man"}</p>
                            : <>
                                <p className="text-white text-sm">{"Texting "+femaledata.fullname1 +" as a man"}</p>
                                <p className="text-white text-sm">{"Package: "+femaledata.package1}</p>
                                <p className="text-white text-sm">Age preference: {femaledata.minage1} - {femaledata.maxage1}</p>
                              </>
                        }
                    </div>
                </div>

                <input
                    className="bg-white text-black placeholder-gray-600 p-2 my-2 w-full rounded-full"
                    placeholder="Search for a specific gentleman:" value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                
                {woman.loading && <p role="status" className="text-white">Loading woman's profile…</p>}
                {woman.error && <div role="alert" className="text-white">{woman.error} <button type="button" onClick={woman.retry}>Retry woman's profile</button></div>}
                {renderSection('Direct Matches', direct, directRef)}
                {renderSection('Non Direct Matches', nonDirect, nonDirectRef)}
                {renderSection('All Matches', all, allRef)}
            </div>
        </>;
}
